"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFormattingControls = addFormattingControls;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _ControlButton = _interopRequireDefault(require("../components/toolbar/ControlButton"));

var _toolbar = require("../constants/toolbar");

var _hsformatting = require("../constants/hsformatting");

var _i18n = require("../utils/i18n");

var _formatting = require("../utils/formatting");

var _utils = require("../utils");

var _utils2 = require("./utils");

var _hsformatting2 = require("tinymce-plugins/constants/hsformatting");

var registerFormatForInheritedStyleOverride = function registerFormatForInheritedStyleOverride(editor, format) {
  var _editor$formatter$reg;

  var inheritedStylesConfig = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting2.hsformattingConfig.OVERRIDE_INHERITED_STYLES_CONFIG) || {};
  var selector = inheritedStylesConfig[format] || [];
  var styles = _formatting.overrideInheritedStyles[format];

  var nonAffectedSelector = _hsformatting.BLOCK_FORMAT_NODES.filter(function (n) {
    return !selector.includes(n);
  }).map(function (s) {
    return s + " > span";
  }).join(',');

  if (!selector.length) {
    return;
  }

  var exact = format === 'underline';
  editor.formatter.register((_editor$formatter$reg = {}, (0, _defineProperty2.default)(_editor$formatter$reg, _hsformatting2.FORMAT_COMMAND_TO_INHERITED_COMMAND[format].on, [{
    selector: selector.join(','),
    styles: (0, _defineProperty2.default)({}, styles.affectedStyles[0], '%value'),
    inline: 'span',
    exact: exact,
    split: true,
    deep: true,
    remove_similar: true
  }]), (0, _defineProperty2.default)(_editor$formatter$reg, _hsformatting2.FORMAT_COMMAND_TO_INHERITED_COMMAND[format].off, [{
    selector: nonAffectedSelector,
    styles: (0, _defineProperty2.default)({}, styles.affectedStyles[0], styles.off),
    remove: 'empty'
  }]), _editor$formatter$reg));
};

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting.i18nNameSpace);

var getControlClickHandler = function getControlClickHandler(editor, format) {
  var overrideFormats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return function (isActive) {
    (0, _utils2.applyFontStyles)(editor, format, overrideFormats, isActive);
  };
};

var controls = [{
  controlName: 'canvasbold',
  iconName: 'bold',
  formatName: 'bold',
  tooltip: 'tooltip.bold',
  getClickHandler: getControlClickHandler
}, {
  controlName: 'canvasitalic',
  iconName: 'italic',
  formatName: 'italic',
  tooltip: 'tooltip.italic',
  getClickHandler: getControlClickHandler
}, {
  controlName: 'canvasunderline',
  iconName: 'underline',
  formatName: 'underline',
  tooltip: 'tooltip.underline',
  getClickHandler: getControlClickHandler
}, {
  controlName: 'canvasstrikethrough',
  iconName: 'strike',
  formatName: 'strikethrough',
  tooltip: 'tooltip.strikethrough',
  getClickHandler: getControlClickHandler
}, {
  controlName: 'canvassuperscript',
  iconName: 'superscript',
  formatName: 'superscript',
  tooltip: 'tooltip.superscript',
  getClickHandler: getControlClickHandler
}, {
  controlName: 'canvassubscript',
  iconName: 'subscript',
  formatName: 'subscript',
  tooltip: 'tooltip.subscript',
  getClickHandler: getControlClickHandler
}];

function addFormattingControls(editor) {
  var inheritedStylesConfig = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting2.hsformattingConfig.OVERRIDE_INHERITED_STYLES_CONFIG) || {};
  controls.forEach(function (_ref) {
    var formatName = _ref.formatName,
        iconName = _ref.iconName,
        tooltip = _ref.tooltip,
        getClickHandler = _ref.getClickHandler,
        controlName = _ref.controlName;
    var lastIsActive = false;
    var eventName = "FormatChanged:" + formatName;

    var formatChangedCallback = function formatChangedCallback(isActive, e) {
      lastIsActive = isActive;
      editor.fire(eventName, (0, _extends2.default)({
        isActive: isActive
      }, e));
    };

    if (editor.formatter) {
      editor.formatter.formatChanged(formatName, formatChangedCallback);
      registerFormatForInheritedStyleOverride(editor, formatName);
    } else {
      editor.on('init', function () {
        editor.formatter.formatChanged(formatName, formatChangedCallback);
        registerFormatForInheritedStyleOverride(editor, formatName);
      });
    }

    editor.addButton(controlName, {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_ControlButton.default, (0, _extends2.default)({
          editor: editor,
          "data-test-id": "toggle-format-" + iconName,
          formatName: formatName,
          iconName: iconName,
          tooltip: i18nKey(tooltip),
          onClick: getClickHandler(editor, formatName, inheritedStylesConfig[formatName]),
          getInitialActive: function getInitialActive() {
            return lastIsActive;
          },
          nodesAffectedByInheritedStyles: inheritedStylesConfig[formatName]
        }, props));
      }
    });
  });
}